import React from "react";

import { Box, CircularProgress, CircularProgressProps } from "@mui/material";

export type IgfdCircularProgressProps = CircularProgressProps & {
  fullScreen?: boolean;
};

/**
 * Full-screen loading indicator.
 * @param props
 * @constructor
 * @ignore
 */
export function CircularProgressCenter({
  fullScreen = true,
  ...rest
}: IgfdCircularProgressProps) {
  return (
    <Box
      sx={
        fullScreen
          ? {
              display: "flex",
              width: "100vw",
              maxHeight: "100%",
              maxWidth: "100%",
              height: "100vh",
              "@supports (height: 100dvh)": {
                height: "100dvh",
              },
            }
          : {
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
              padding: 8,
            }
      }
    >
      <Box m="auto">
        <CircularProgress {...rest} />
      </Box>
    </Box>
  );
}
